import { getPetBreed } from "../api/apimethods";

const fetchPetBreeds = async () => {
    try {
      const response = await getPetBreed();
      // Process the response data and create the colours options array
      const petBreeds = response.data;
      return petBreeds;
    } catch (error) {
      console.error("Error fetching animal types:", error);
      return [];
    }
  };
  
  
  export default fetchPetBreeds;